export default __webpack_public_path__ + "static/media/ufa.47ec0f02.pdf";